/* Launch confetti: one short gold-and-blue burst, once per browser session, on the
   home page and the kit page only. It pours out of the announcement bar (3 Nov: was two cannons from the bottom corners).
   - Skipped when the visitor prefers reduced motion.
   - Starts after the page has loaded and the browser is idle; never blocks input
     (canvas is pointer-events:none) and removes itself when finished.
   - ?confetti=1 on the URL forces it (for checking); it does not touch the session flag.
   To retire it: delete the <script> line in layout/theme.liquid. */
(function () {
  'use strict';
  var path = location.pathname.replace(/\/+$/, '') || '/';
  var forced = /[?&]confetti=1(&|$)/.test(location.search);
  var onPage = path === '/' || path.indexOf('/products/') === 0;
  if (!onPage) return;
  try {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  } catch (e) {}
  var KEY = 'unc_launch_confetti_v1';
  if (!forced) {
    try { if (sessionStorage.getItem(KEY)) return; } catch (e) {}
  }

  function run() {
    if (document.hidden) {
      document.addEventListener('visibilitychange', function once() {
        if (!document.hidden) { document.removeEventListener('visibilitychange', once); run(); }
      });
      return;
    }
    if (!forced) { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = window.innerWidth, h = window.innerHeight;
    var canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = 'position:fixed;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:2147483000;';
    canvas.width = Math.round(w * dpr);
    canvas.height = Math.round(h * dpr);
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.scale(dpr, dpr);
    document.body.appendChild(canvas);

    var bar = document.querySelector('.announcement-bar, #shopify-section-announcement-bar');
    var br = bar ? bar.getBoundingClientRect() : null;
    var originY = br && br.bottom > 0 ? Math.max(4, Math.min(br.top + br.height / 2, h * 0.2)) : 4;
    var colours = ['#D4AF37', '#F1D77A', '#B8902A', '#4A90E2', '#9CC3F2', '#FFFFFF'];
    var small = w < 600;
    var perCannon = small ? 60 : 100;
    var parts = [];
    /* Out of the bar: two corner cannons fire down and inward, and a curtain drops from along the bar's width. */
    function cannon(x, dir, count) {
      for (var i = 0; i < count; i++) {
        var angle = (90 - dir * (8 + Math.random() * 45)) * Math.PI / 180;
        var speed = (small ? 6 : 8) + Math.random() * (small ? 7 : 10);
        parts.push(make(x, originY, Math.cos(angle) * speed, Math.sin(angle) * speed));
      }
    }
    function curtain(count) {
      for (var i = 0; i < count; i++) {
        parts.push(make(Math.random() * w, originY, (Math.random() - 0.5) * 4, 1 + Math.random() * 5));
      }
    }
    function make(x, y, vx, vy) {
      return {
        x: x, y: y, vx: vx, vy: vy,
        size: 8 + Math.random() * 8,
        rot: Math.random() * Math.PI * 2, vr: (Math.random() - 0.5) * 0.35,
        flip: Math.random() * Math.PI * 2, vf: 0.12 + Math.random() * 0.2,
        circle: Math.random() < 0.25,
        colour: colours[(Math.random() * colours.length) | 0]
      };
    }
    cannon(0, 1, perCannon);
    cannon(w, -1, perCannon);
    curtain(small ? 50 : 90);
    var second = false;

    var DURATION = 5000, start = null;
    function frame(ts) {
      if (start === null) start = ts;
      var t = ts - start;
      if (!second && t > 450) { second = true; cannon(0, 1, perCannon >> 1); cannon(w, -1, perCannon >> 1); curtain(small ? 30 : 60); }
      ctx.clearRect(0, 0, w, h);
      var fade = t > DURATION - 900 ? Math.max(0, (DURATION - t) / 900) : 1;
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.vx *= 0.985; p.vy = p.vy * 0.985 + 0.16;
        p.x += p.vx; p.y += p.vy; p.rot += p.vr; p.flip += p.vf;
        ctx.save();
        ctx.globalAlpha = fade;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.scale(1, Math.cos(p.flip));
        ctx.fillStyle = p.colour;
        if (p.circle) { ctx.beginPath(); ctx.arc(0, 0, p.size * 0.45, 0, Math.PI * 2); ctx.fill(); }
        else ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
        ctx.restore();
      }
      if (t < DURATION) requestAnimationFrame(frame);
      else if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
    }
    requestAnimationFrame(frame);
  }

  function schedule() {
    var go = function () { setTimeout(run, forced ? 300 : 900); };
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2500 });
    else go();
  }
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule);
})();
